import { default as app_45errorzy18MbT1ftMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue?macro=true";
import { default as _91id_93wMh4rtODDFMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue?macro=true";
import { default as _91id_93ds81XvzN1PMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue?macro=true";
import { default as _91id_93o6WQg6ncqWMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue?macro=true";
import { default as _91id_93KY4jxvZlPlMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue?macro=true";
import { default as indexZsTtVYhpewMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue?macro=true";
import { default as indexqkmpZB3WY7Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue?macro=true";
import { default as indexOgbTHaNeSsMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue?macro=true";
import { default as show_45allLwKWXV7apUMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue?macro=true";
import { default as indexxgM65POKqhMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue?macro=true";
import { default as forgotNaKhMnciUKMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue?macro=true";
import { default as indexx8LaCBoVEUMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue?macro=true";
import { default as sign_45in5z6kfJTK78Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue?macro=true";
import { default as all_45on_45demandLzgeGIuz1bMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue?macro=true";
import { default as all_45programsfKB6DiUTb1Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue?macro=true";
import { default as index5sVCLzn0luMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue?macro=true";
import { default as show_45all_45fav_45channelsK5xrp7cfdzMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue?macro=true";
import { default as indexfEsbjm13jIMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playersnflgnMf02Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue?macro=true";
import { default as indexfvOmFQFJlFMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue?macro=true";
import { default as show_45allctSbeipLYnMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue?macro=true";
import { default as about_45usiMWfLRgci1Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue?macro=true";
import { default as indexnkYa2JWsjjMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue?macro=true";
import { default as clear_45cacheaBVqd0JdoTMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue?macro=true";
import { default as dev_45mode9M094HQzASMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue?macro=true";
import { default as favorites1dlP3f2VWPMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue?macro=true";
import { default as indexhSPFGCV448Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue?macro=true";
import { default as indexjRZM2KdglhMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue?macro=true";
import { default as indexDiWkz8w04DMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue?macro=true";
import { default as privacy_45policyXnrbPv59YmMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue?macro=true";
import { default as serviceKoSvd4xWKoMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/service.vue?macro=true";
import { default as software_45licenseuAU9XOz9GdMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/software-license.vue?macro=true";
import { default as subscriptioniKxCNHO7BLMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue?macro=true";
import { default as settingsAE8rZiKJxbMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue?macro=true";
import { default as loaderN2gCPLN4hcMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue?macro=true";
import { default as logowV7BEvbSYCMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxiQelm7xtmR2Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue?macro=true";
import { default as indexEukxQFRNB2Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue?macro=true";
import { default as _91id_93o7TVOZmf0HMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue?macro=true";
import { default as _91id_93flW6heyoYUMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue?macro=true";
import { default as _91id_934pf1XqkidTMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue?macro=true";
import { default as indexjvP2bkteCQMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue?macro=true";
import { default as show_45all_45channelswRlv8AHGWSMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue?macro=true";
import { default as show_45all_45moviesZT0caSGq5YMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue?macro=true";
import { default as show_45all_45subitemsL5Iz3y0VhFMeta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue?macro=true";
import { default as show_45allwXiYJYW5E5Meta } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue?macro=true";
export default [
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errorzy18MbT1ftMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue").then(m => m.default || m)
  },
  {
    name: "detailsCast-id",
    path: "/detailsCast/:id()",
    meta: _91id_93wMh4rtODDFMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsPrograms-id",
    path: "/detailsPrograms/:id()",
    meta: _91id_93ds81XvzN1PMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodMovies-id",
    path: "/detailsVodMovies/:id()",
    meta: _91id_93o6WQg6ncqWMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodSeries-id",
    path: "/detailsVodSeries/:id()",
    meta: _91id_93KY4jxvZlPlMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue").then(m => m.default || m)
  },
  {
    name: "guide",
    path: "/guide",
    meta: indexZsTtVYhpewMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: "help",
    path: "/help",
    meta: indexqkmpZB3WY7Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: indexOgbTHaNeSsMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: "home-show-all",
    path: "/home/show-all",
    meta: show_45allLwKWXV7apUMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexxgM65POKqhMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-forgot",
    path: "/login/forgot",
    meta: forgotNaKhMnciUKMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexx8LaCBoVEUMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-sign-in",
    path: "/login/sign-in",
    meta: sign_45in5z6kfJTK78Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-on-demand",
    path: "/mytv/all-on-demand",
    meta: all_45on_45demandLzgeGIuz1bMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-programs",
    path: "/mytv/all-programs",
    meta: all_45programsfKB6DiUTb1Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue").then(m => m.default || m)
  },
  {
    name: "mytv",
    path: "/mytv",
    meta: index5sVCLzn0luMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue").then(m => m.default || m)
  },
  {
    name: "mytv-show-all-fav-channels",
    path: "/mytv/show-all-fav-channels",
    meta: show_45all_45fav_45channelsK5xrp7cfdzMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue").then(m => m.default || m)
  },
  {
    name: playersnflgnMf02Meta?.name,
    path: "/player",
    meta: playersnflgnMf02Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue").then(m => m.default || m),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: indexfvOmFQFJlFMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: "search-show-all",
    path: "/search/show-all",
    meta: show_45allctSbeipLYnMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-about-us",
    path: "about-us",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue").then(m => m.default || m)
  },
  {
    name: "settings-account",
    path: "account",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-clear-cache",
    path: "clear-cache",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: "settings-dev-mode",
    path: "dev-mode",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue").then(m => m.default || m)
  },
  {
    name: "settings-favorites",
    path: "favorites",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue").then(m => m.default || m)
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-parent-control",
    path: "parent-control",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-player",
    path: "player",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-privacy-policy",
    path: "privacy-policy",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "settings-service",
    path: "service",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/service.vue").then(m => m.default || m)
  },
  {
    name: "settings-software-license",
    path: "software-license",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/software-license.vue").then(m => m.default || m)
  },
  {
    name: "settings-subscription",
    path: "subscription",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue").then(m => m.default || m)
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue").then(m => m.default || m)
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue").then(m => m.default || m)
  },
  {
    name: "trailer",
    path: "/trailer",
    meta: indexEukxQFRNB2Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-detail-genre-id",
    path: "/vod/detail-genre/:id()",
    meta: _91id_93o7TVOZmf0HMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-premium-id",
    path: "/vod/genres-premium/:id()",
    meta: _91id_93flW6heyoYUMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-id",
    path: "/vod/genres/:id()",
    meta: _91id_934pf1XqkidTMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod",
    path: "/vod",
    meta: indexjvP2bkteCQMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-channels",
    path: "/vod/show-all-channels",
    meta: show_45all_45channelswRlv8AHGWSMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-movies",
    path: "/vod/show-all-movies",
    meta: show_45all_45moviesZT0caSGq5YMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-subitems",
    path: "/vod/show-all-subitems",
    meta: show_45all_45subitemsL5Iz3y0VhFMeta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all",
    path: "/vod/show-all",
    meta: show_45allwXiYJYW5E5Meta || {},
    component: () => import("C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue").then(m => m.default || m)
  }
]